// extracted by mini-css-extract-plugin
module.exports = {"container":"facet-FacetGroupTopFacets__container--3Z_z_","large":"facet-FacetGroupTopFacets__large--leOZh","medium":"facet-FacetGroupTopFacets__medium--ub3Q2"};